module.exports = __webpack_public_path__ + "static/img/pc-10.fc38f67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x3/pc-10.jpg
// module id = DqVF
// module chunks = 1